import httpClient, { handleSuccess, handleError, apiHeader } from './httpClient'
import dayjs from 'dayjs'

export function list() {
  return httpClient.get('achievement/list').then(handleSuccess).catch(handleError)
}

export function info(achievementId) {
  const params = new URLSearchParams()
  params.append('achievement_id', achievementId)

  return httpClient
    .get('achievement/info', {
      params
    })
    .then(handleSuccess)
    .catch(handleError)
}

export function downloadFile(fileId) {
  const params = new URLSearchParams()
  params.append('id', fileId)

  return httpClient.post('achievement/download_file', params, apiHeader).then(handleSuccess).catch(handleError)
}

export function save(formData, filePaths = [], deletedFiles = []) {
  const params = new URLSearchParams()

  params.append('user_id', formData.user_id)
  if (formData.achievement_id) {
    params.append('achievement_id', formData.achievement_id)
  }
  params.append('title', formData.title)
  params.append('detail', formData.detail)
  params.append('achievement_type_id', formData.achievement_type_id)
  params.append('delete_files', JSON.stringify(deletedFiles))
  params.append('is_draft', formData.is_draft)

  if (formData.link) {
    params.append('link', formData.link)
  }
  if (filePaths.length) {
    params.append('tmp_upload_files', JSON.stringify(filePaths))
  }
  if (Number(formData.achievement_type_id) === 8) {
    // TODO: idの決めうちを止める
    params.append('program_time_id', formData.completion_program_time_id)
  } else {
    params.append('program_time_id', '0')
  }
  if (formData.issued_at) {
    params.append('issued_at', dayjs(formData.issued_at).format('YYYY/MM/DD'))
  }

  return httpClient.post('achievement/save', params, apiHeader).then(handleSuccess).catch(handleError)
}

export function _delete(achievementId) {
  const params = new URLSearchParams()
  params.append('achievement_id', Number(achievementId))

  return httpClient.post('achievement/delete', params, apiHeader).then(handleSuccess).catch(handleError)
}

export function uploadTmpFile(uploadFile, uploadProgress, token) {
  const params = new FormData()
  params.append('tmp_file', uploadFile)
  const header = Object.assign({
    onUploadProgress: uploadProgress,
    cencelToken: token
  }, apiHeader)

  return httpClient
    .post('achievement/upload_tmp_file', params, header)
    .then(handleSuccess)
    .catch(handleError)
}
